import {
  DocumentFormDataApi,
  FormData as FormDataGenerated,
} from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import Uuid from '../../../model/Uuid';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import { mapStadium } from '../../../model/legislativnyMaterial/StadiumMaterialu';
import FormData from '../../../model/legislativnyMaterial/FormData';

const client = new DocumentFormDataApi(apiConfiguration(evidenciaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const getActiveDocumentFormData = async (
  legMaterialUuid: Uuid,
  typDokumentuKod: string,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<object>> => {
  const {
    data,
    status,
  } = await client.getDocumentFormData(legMaterialUuid, typDokumentuKod, stadiumUuid, headers);

  return {
    data,
    responseCode: status,
  };
};

function map(formDataResponse: FormDataGenerated): FormData {
  return {
    formData: formDataResponse.formData ? JSON.parse(formDataResponse.formData) : null,
    stadium: formDataResponse.stadium ? mapStadium(formDataResponse.stadium) : null,
  };
}

export const getLatestDocumentFormData = async (
  legMaterialUuid: Uuid,
  typDokumentuKod: string,
  stadiumUuid: Uuid,
  headers?: object,
): Promise<ClientResponse<FormData>> => {
  const {
    data,
    status,
  } = await client.getLatestDocumentFormData(legMaterialUuid, typDokumentuKod, stadiumUuid, headers);

  return {
    data: data ? map(data) : null,
    responseCode: status,
  };
};
